<template>
  <div>
    <div
      v-for="item in data"
      :key="item.value"
      class="check-item"
      :class="{ 'is-children': isChildren && !item.children }"
    >
      <b-form-checkbox
        v-model="selected"
        :disabled="handleDisabled(item)"
        class="mt-1 pr-1 cur-p"
        style="display:inline-block;"
        :value="item.value"
        @change="toggleAll($event, item.value)"
      >
        {{ item.label }}
      </b-form-checkbox>
      <div v-if="item.children" class="ml-2">
        <check-item
          :value.sync="value"
          :data="item.children"
          :is-children="true"
          :disabled="disabled"
          @input="change"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { BFormCheckbox } from 'bootstrap-vue'
import { deepClone } from '@/util/util'

export default {
  name: 'CheckItem',
  components: {
    BFormCheckbox,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
    isChildren: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => [],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      selectedVal: [],
      selected: [],
    }
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(e) {
        this.selectedVal = e
        this.selected = e
      },
    },
  },
  methods: {
    toggleAll(e, val) {
      const res = Array.from(new Set([...e, ...this.selectedVal]))
      if (this.disabled) {
        return
      }
      if (e.indexOf(val) === -1) {
        res.splice(
          res.findIndex((item) => item === val),
          1
        )
      }
      this.$emit('input', res)
    },
    handleDisabled(item) {
      return typeof this.disabled === 'boolean'
        ? this.disabled
        : !!item.disabled
    },
    change(e) {
      this.$emit('input', e)
    },
  },
}
</script>

<style lang="scss" scoped>
.is-children {
  display: inline-block;
}
</style>
